import React from "react"
import { useFormContext, useFormState } from "react-hook-form"
import {
    BasicInputWithError as BasicInputWithErrorBase,
    FloatLabelInput,
    InputWithError as InputWithErrorBase,
} from "@silversea-ssc/ui-components-react"
import { ErrorMessage } from "@hookform/error-message"

interface InputWithErrorProps {
    name: string
    label: string
    children: FloatLabelInput
    forceLabelRenderAsFocused?: boolean
}

interface BasicInputWithErrorProps {
    name: string
    id: string
    children: FloatLabelInput
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getNestedValue = (object: any, path: string | string[]) => {
    let searchPath = path
    if (!Array.isArray(searchPath)) {
        searchPath = searchPath.split(".")
    }
    return searchPath.reduce(function (prev, cur) {
        if (prev && prev[cur] !== undefined) {
            return prev[cur]
        }
        return undefined
    }, object)
}

const InputWithError: React.FC<React.PropsWithChildren<InputWithErrorProps>> = (props) => {
    const { name } = props

    const { control } = useFormContext()
    const { errors } = useFormState({ control })

    const hasError = errors && getNestedValue(errors, name)

    const errorMessageComponent = <ErrorMessage data-test-id="input-error" as="div" errors={errors} name={name} />

    return (
        <InputWithErrorBase
            id=""
            {...props}
            validationState={hasError ? "error" : undefined}
            errorMessageComponent={errorMessageComponent}
        />
    )
}

export const BasicInputWithError: React.FC<React.PropsWithChildren<BasicInputWithErrorProps>> = (props) => {
    const { name } = props

    const { control } = useFormContext()
    const { errors } = useFormState({ control })

    const hasError = errors && getNestedValue(errors, name)

    const errorMessageComponent = <ErrorMessage data-test-id="input-error" as="div" errors={errors} name={name} />

    return (
        <BasicInputWithErrorBase
            {...props}
            validationState={hasError ? "error" : undefined}
            errorMessageComponent={errorMessageComponent}
        />
    )
}

export default InputWithError
